import { FilterTypeEnum, Tag } from './Tags';

export interface SavedSearchFilterDto {
  filterType: string;
  tags: string[];
}

export interface SavedSearchDto {
  id: string;
  name: string;
  keywords?: string;
  filters?: SavedSearchFilterDto[];
  dateRange?: SavedSearchDateRange | null;
  createdAt: string;
  updatedAt: string;
  pageName: SavedSearchPage;
  sort?: string;
  tab?: string;
}

export interface SavedSearchFilter {
  filterType: FilterTypeEnum;
  tags: Tag[];
}

export interface SavedSearch {
  id: string;
  name: string;
  keywords?: string;
  filters: SavedSearchFilter[];
  dateRange?: SavedSearchDateRange | null;
  createdAt: string;
  updatedAt: string;
  pageName: SavedSearchPage;
  sort?: string;
  tab?: string;
}

export interface SavedSearchDateRange {
  startDate?: string;
  endDate?: string;
  relativeRange?: FILTER_RELATIVE_DATE_RANGE;
}

export enum SavedSearchPage {
  GlobalSearch = 'Global Search',
}

export enum FILTER_RELATIVE_DATE_RANGE {
  LAST_24HRS = 'LAST_24HRS',
  LAST_7DAYS = 'LAST_7DAYS',
  LAST_30DAYS = 'LAST_30DAYS',
  LAST_90DAYS = 'LAST_90DAYS',
}
